"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Layers3 } from "lucide-react";
const faqs = [{
  question: "What is EloRAG pricing actually for?",
  answer: "EloRAG pricing covers the platform layer: controlled retrieval, approved-only access, citation-based answers, refusal logic, tenant-aware delivery, and related deployment capabilities."
}, {
  question: "Is EloRAG still available on AppSumo?",
  answer: "No. EloRAG is no longer available on AppSumo and is now offered through monthly subscriptions."
}, {
  question: "What does BYO-Key mean?",
  answer: "Customers provide their own LLM and OCR API keys. EloRAG charges for the platform, while variable model and OCR usage are billed directly by the chosen providers."
}, {
  question: "Does EloRAG include unlimited usage?",
  answer: "No. All plans use hard backend-enforced caps. EloRAG does not offer unlimited usage or silent overages."
}, {
  question: "What happens when we hit our plan limits?",
  answer: "At 80% usage, EloRAG shows a warning. At 100%, additional usage is blocked until you upgrade the plan or add a Capacity Pack."
}, {
  question: "Are Capacity Packs optional?",
  answer: "Yes. Capacity Packs are optional monthly add-ons used when you need more storage, vectors, or queries without changing your core plan."
}, {
  question: "Does one Capacity Pack expand storage, vectors, and queries at the same time?",
  answer: "No. Each Capacity Pack expands one resource type only. You choose whether the pack applies to storage, vectors, or queries."
}, {
  question: "Is white-label included in the core plans?",
  answer: "No. White-label is a separate monthly add-on and is not included by default in the core subscription plans."
}, {
  question: "What is required to activate white-label?",
  answer: "White-label requires Business plan or higher, a White-Label subscription, and at least one Capacity Pack."
}, {
  question: "Can agencies use EloRAG for client delivery?",
  answer: "Yes. EloRAG supports multi-tenant delivery and white-label options for agencies and resellers that want to provide branded RAG environments to clients."
}, {
  question: "Does EloRAG answer from the public internet?",
  answer: "No. EloRAG is designed to answer from approved content only. If approved evidence is insufficient, the platform refuses instead of guessing."
}];
export default function PricingFaq() {
  return <section id="pricing-faq" className="bg-background py-16 sm:py-20">
      <div className="mx-auto max-w-4xl px-6 lg:px-8">
        <div className="mx-auto mb-12 max-w-2xl text-center">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
            <Layers3 className="size-4" />
            Pricing FAQs
          </div>

          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Frequently asked questions about pricing
          </h2>
          <p className="mt-4 text-lg leading-8 text-muted-foreground">
            Clear answers about subscriptions, capacity, white-label requirements, and EloRAG’s deployment model.
          </p>
        </div>

        <div className="mx-auto max-w-4xl">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="rounded-lg border border-border/70 bg-card px-6 shadow-[0_8px_20px_-16px_rgba(0,0,0,0.12)]">
                <AccordionTrigger className="text-left text-base font-semibold text-foreground hover:text-primary hover:no-underline sm:text-lg">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base leading-7 text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <p className="text-base text-muted-foreground">
            Still have questions about pricing or deployment fit?
          </p>
          <Button asChild variant="outline" size="lg">
            <Link to="/BookADemoContactSalesPage">Talk to Sales</Link>
          </Button>
        </div>
      </div>
    </section>;
}